module.exports = __webpack_public_path__ + "img/newsImg3-13.9666ff32.png";